import { gql } from '@apollo/client';

const UPDATE_MACHINE_TO_CUSTOMER = gql`
    mutation UpdateDeviceToCustomer($input: AddDeviceCustomer!) {
        updateDeviceToCustomer(input: $input) {
            data {
                connection_status
                connection_type
                createdAt
                device_id
                device_name
                id
                machine_name
                operation_mode
                updatedAt
                user_id
            }
            message
            success
        }
    }
`;

export { UPDATE_MACHINE_TO_CUSTOMER };
